import { gql } from 'react-apollo';
// Toaster
import { toastr } from 'react-redux-toastr';
import {
    UPDATE_REVIEW_START,
    UPDATE_REVIEW_SUCCESS,
    UPDATE_REVIEW_ERROR,

} from '../../../constants';
import getReviewsDetails from '../../../components/siteadmin/UserReviewsManagement/userReviewsQuery.graphql';

export function updateReviewStatus(id, type) {

    return async (dispatch, getState, { client }) => {

        dispatch({
            type: UPDATE_REVIEW_START,
        });

        let mutation = gql`
        mutation updateReview($id: Int, $type: String){
            updateReview(id: $id, type: $type) {
              status
            }
          }
    `;

        try {

            const { data } = await client.mutate({
                mutation,
                variables: { id, type },
                refetchQueries: [{
                    query: getReviewsDetails,
                    variables: {
                        currentPage: 1
                    }
                }]
            });

            if (data.updateReview.status === "success") {
                dispatch({
                    type: UPDATE_REVIEW_SUCCESS,
                });
                toastr.success("Success!", "updated successfully");
            } else {
                dispatch({
                    type: UPDATE_REVIEW_ERROR,
                    payload: {
                        status
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_REVIEW_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}



